'use strict';

namespace Core {

    class MailingListSignUp {

        private email: string;
        private emailPattern: RegExp = /^\S+@\S+\.\S+[^\.]$/;

        private success: boolean = false;
        private error: boolean = false;
        private showOptOut: boolean = false;

        constructor (
            private authService: any,
            private $scope: ng.IScope,
            private $rootScope: ng.IRootScopeService,
            private broker: any,
            private abTest: any,
            private analytics
        ) {
            this.$rootScope.$on('$routeChangeStart', () => {
                this.success = false;
                this.error = false;
                this.resetForm();
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('mailingListSignUp');
            });
        }

        openOptOut (e): void {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.showOptOut = true;
            this.analytics.track('mixpanel', 'GDPRUnsubscribe');
        }

        closeOptOut (e): void {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.showOptOut = false;
        }

        submit (): void
        {
            const data = {
                Email: this.email,
                ContextTag: 'Source:Website-Newsletter',
                Source: 'TravelRepublic',
                SignupReason: 'Newsletter Signup Footer'
            };

            this.authService
                .registerForNewsletter(data)
                .success(() => {
                    this.success = true;
                    this.error = false;
                    this.resetForm();
                })
                .error(() => {
                    this.error = true;
                });
        }

        resetForm (): void {
            if (this.$scope.mailingListForm) {
                this.$scope.mailingListForm.$setPristine();
                this.$scope.mailingListForm.$setUntouched();
            }
            this.email = '';
        }
    }

    angular
        .module('core')
        .directive('mailingListSignUp', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                replace: true,
                controller: MailingListSignUp,
                controllerAs: 'msu',
                templateUrl: (el, attr) => {
                    const templateName = attr.templateVersion ? attr.templateVersion : 'mailinglistsignup';
                    return `partials/home/directivetemplate?type=${templateName}`;
                },
            };
        });
}
